/* eslint-disable vue/no-side-effects-in-computed-properties */
<template>
  <div class="oversea-container">
    <el-form ref="form"
             :rules="rules"
             :model="form"
             label-position="top"
             label-width="80px">
      <!--账户选择-->
      <el-form-item :label="$t('withdrawal.tradeAccount')"
                    prop="tradeAccount">
        <bAccountNumbersSelect v-model="form.tradeAccount"
                               ref="AccountNumbers"
                               test_id="btn_trade_account"
                               @change="tradeAccountChange"></bAccountNumbersSelect>
      </el-form-item>
      <!--外汇账户余额-->
      <div v-if="type === 'FOREX'">
        <el-form-item v-if="showBalance"
                      :label="$t('withdrawal.acceptableAmount')"
                      class="input_currency">
          <img @click="helpDialog=true"
               class="help-box"
               src="@/assets/images/help.png"
               alt="">
          <el-input placeholder=""
                    readonly
                    :disabled="true"
                    class="input_aomut">
            <template slot="prepend">USD</template>
            <div slot="prefix"
                 class="money-icon">${{formatUSDBalance}}</div>
          </el-input>
        </el-form-item>
      </div>
      <!--证券/期货账户余额-->
      <div v-if="type !== '' && type!=='FOREX'">
        <el-form-item v-if="showBalance"
                      :label="$t('withdrawal.availableAmount')"
                      class="input_currency">
          <el-input placeholder=""
                    readonly
                    :disabled="true"
                    class="input_aomut">
            <template slot="prepend">HKD</template>
            <div slot="prefix"
                 class="money-icon">${{formatHKDBalance}}</div>
          </el-input>
          <el-input placeholder=""
                    readonly
                    :disabled="true"
                    class="input_aomut line-space-input">
            <template slot="prepend">USD</template>
            <div slot="prefix"
                 class="money-icon">${{formatUSDBalance}}</div>
          </el-input>
          <el-input placeholder=""
                    readonly
                    :disabled="true"
                    class="input_aomut line-space-input">
            <template slot="prepend">CNY</template>
            <div slot="prefix"
                 class="money-icon">¥{{formatCNYBalance}}</div>
          </el-input>
        </el-form-item>
      </div>
      <!-- 英文名/中文拼音-->
      <el-form-item :label="$t('withdrawal.name')">
        <el-input :placeholder="$t('common.please_input')"
                  test_id="withdrawal_name"
                  v-model="withdrawal_name"
                  readonly="readonly">
        </el-input>
      </el-form-item>
      <!-- 银行名称-->
      <el-form-item :label="$t('withdrawal.bankName')"
                    prop="withdrawal_bank_name">
        <el-input :placeholder="$t('common.please_input')"
                  v-model="form.withdrawal_bank_name"
                  test_id="withdrawal_bankName">
        </el-input>
      </el-form-item>
      <!--银行卡号-->
      <el-form-item :label="$t('withdrawal.bankNo')"
                    prop="withdrawal_bank_card">
        <el-input :placeholder="$t('common.please_input')"
                  v-model="form.withdrawal_bank_card"
                  test_id="withdrawal_bankNo">
        </el-input>
      </el-form-item>
      <!--SWIFT CODE-->
      <el-form-item :label="$t('withdrawal.swiftNo')"
                    prop="withdrawal_swift_no">
        <el-input :placeholder="$t('common.please_input')"
                  v-model="form.withdrawal_swift_no"
                  test_id="withdrawal_swiftNo">
        </el-input>
      </el-form-item>
      <!--取款金额-->
      <el-form-item :label="$t('withdrawal.withdrawal_amount')"
                    prop="withdrawal_amount"
                    ref="withdrawal_amount">
        <el-input type="number"
                  :placeholder="$t('common.please_input')"
                  v-model="form.withdrawal_amount"
                  test_id="input_withdrawal_amount"
                  class="input_aomut">
          <template slot="prepend">{{withdrawalAmountCurrency}}</template>
          <div slot="prefix"
               class="money-icon">$</div>
        </el-input>
      </el-form-item>
      <div class="service-charge">
        <span class="charge-left">{{ $t("withdrawal.unhkServiceFee") }}</span>
        <span class="charge-right" v-if="curChargeInfo.businessCcy && curChargeInfo.businessCcy !== curChargeInfo.ccy">
          ≈ {{ this.serviceCharge.toFixed(2) }} {{ withdrawalAmountCurrency }}
          ({{curChargeInfo.amount}} {{curChargeInfo.ccy}})
        </span>
        <span class="charge-right" v-else>{{ this.serviceCharge.toFixed(2) }} {{ withdrawalAmountCurrency }}</span>
      </div>
      <!--上传图片-->
      <el-form-item>
        <div class="tips-font-style"
             v-if="type === 'FOREX' || type==='PM'">{{$t('withdrawal.withdrawalTips.uploadTips.mt5Tip')}}</div>
        <div class="tips-font-style"
             v-else>{{$t('withdrawal.withdrawalTips.uploadTips.tip1')}}</div>
      </el-form-item>
      <el-form-item :label="$t('withdrawal.withdrawalTips.uploadTips.uploadTitle')"
                    prop="checkUpload">
        <uploadPicture ref="uploadPicture"
                       @uploadHandle="uploadHandle"></uploadPicture>
      </el-form-item>

      <el-form-item>
        <div class="depositReciepTips">
          <u class="ReciepTipsTitle">{{$t('withdrawal.withdrawalTipsTitle')}}</u>
          <p>
            <u>{{$t('withdrawal.withdrawalTips.wireTransfer.title')}}</u>
          <p>
            {{$t('withdrawal.withdrawalTips.wireTransfer.tips')}}
          </p>
          <p>
            <u>{{$t('withdrawal.withdrawalTips.other.title')}}</u>
          <p>
            {{$t('withdrawal.withdrawalTips.other.tips')}}
          </p>
          <p>
            <u>{{$t('withdrawal.withdrawalTips.exchangePriceDifferenceBank.title')}}</u>
          <p>
            {{$t('withdrawal.withdrawalTips.exchangePriceDifferenceBank.tips')}}
          <p>{{$t('withdrawal.withdrawalTips.exchangePriceDifferenceBank.example')}}</p>
          <p>
            <u>{{$t('withdrawal.withdrawalTips.exchangePriceDifferenceCompany.title')}}</u>
          <p>
            {{$t('withdrawal.withdrawalTips.exchangePriceDifferenceCompany.tips')}}
          <p>
            {{$t('withdrawal.withdrawalTips.exchangePriceDifferenceCompany.example')}}
          </p>
        </div>
      </el-form-item>

      <el-form-item prop='checked'>
        <el-checkbox class="checkboxTips"
                     test_id="have_read_withdrawal_detailed"
                     v-model="checked">{{$t('withdrawal.haveRead')}}</el-checkbox>
      </el-form-item>
      <el-form-item class="text-center">
        <el-button class="submit-primary-btn"
                   test_id="button_submit"
                   :loading="subLoading"
                   type="primary"
                   @click="submitFn('form')">
          {{$t('withdrawal.button_submit')}} </el-button>
      </el-form-item>
    </el-form>
    <el-dialog :title="$t('withdrawal.acceptableAmount')"
               class="help-dialog"
               :visible.sync="helpDialog"
               width="30%"
               :before-close="handleClose">
      <p>{{$t('withdrawal.largestAmount')}}</p>
    </el-dialog>
  </div>
</template>
<script>
import complete1 from '../../fund-transfer/info-dialog.vue'
import { mapGetters } from 'vuex'
import uploadPicture from './uploadPicture'
import api1 from '@/api/v2/withdrawal'
import tradeApi from '@/api/v2/trade'
import { getHandingCharge } from '@/api/v2/fund'
export default {
  components: { uploadPicture, confirm },
  props: {
    cashList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    var checkInputBlance = (rule, value, callback) => {
      // console.log('dddkdkdkdkdk>>>', this.form.withdrawal_amount, this.available_fund)
      var reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
      const flagBalanceObj = {
        STOCK: this.HKDBalance,
        FUTURES: this.HKDBalance,
        FOREX: this.type === 'FOREX' ? this.mt5Amount : this.USDBalance,
        PM: this.USDBalance,
        FUND: this.HKDBalance
      }
      const flagBalance = flagBalanceObj[this.type] ? flagBalanceObj[this.type] : 0
      if (!value) {
        callback(new Error(this.$t('withdrawal.error_withdrawal_amount_1')))
      } else if (this.showBalance && +value > +this.totalAmount) {
        callback(new Error(this.$t('withdrawal.error_withdrawal_amount') + this.withdrawalAmountCurrency + ' ' + this.Util.formatCurrency(this.totalAmount)))
      } else if (this.showBalance && +value > +flagBalance && this.type === 'FOREX') {
        callback(new Error(this.$t('withdrawal.error_withdrawal_amount_mt5')))
      } else if (+this.form.withdrawal_amount < 0.01) {
        callback(new Error(this.$t('withdrawal.error_withdrawal_amount_2')))
      } else if (!reg.test(value)) {
        callback(new Error(this.$t('withdrawal.error_withdrawal_amount_3')))
      } else {
        callback()
      }
    }
    var checkInputAccountNum = (rule, value, callback) => {
      if (!this.form.tradeAccount) {
        callback(new Error(this.$t('withdrawal.error_account_number')))
      } else {
        callback()
      }
    }
    var checkedVal = (rule, value, callback) => {
      console.log(rule, value)
      var f = rule.field
      if (!this[f]) {
        return callback(new Error(this.$t('applyTradeAccount.checked')))
      }
      callback()
    }
    var checkSwiftCode = (rule, value, callback) => {
      var reg = /^[A-Za-z0-9]+$/
      if (!reg.test(value)) {
        callback(new Error(this.$t('withdrawal.error_withdrawal_swift_no')))
      } else {
        callback()
      }
    }
    return {
      text: 'noWithdrawal',
      src: require('@/assets/images/noWithdrawal.png'),
      componentDialog1: complete1, // 弹窗内容
      buttons: [],
      router: 'withdrawal',
      IsCancelShow: false,
      param: {
        title: 'withdrawalTitle',
        links: [
          {
            title: 'home'
          },
          {
            title: 'withdrawalTitle'
          }
        ]
      },
      tmp_account_number: '',
      closeModal: false,
      orderId: '',
      loadingSub: false,
      bankCardNumber: '',
      available_fund: '',
      currency: '--', // 币种
      form: {
        tradeAccount: '',
        withdrawal_amount: '',
        withdrawal_name: '',
        bankType: 'OTHER',
        withdrawal_bank_name: '',
        withdrawal_bank_card: '',
        withdrawal_swift_no: ''
      },
      accountId: '',
      bank_card_name: '',
      parentList: [],
      withdrawal_method: 'LOCAL',
      submittedOrder: [],
      showClose: false, // 关闭小图标
      contiune: true, // 继续按钮
      IsCodeShow: false,
      dialogVisible: false, // 默认关闭弹窗
      loading: false,
      accountInfo: '',
      accountNumber: '',
      params: {
        orderId: ''
      },
      currencyList: [],
      accountType: '',
      tradeAccountType: '',
      oldListData: [],
      cancelOrderId: '',
      showBalance: true,
      checked: false,
      imageKeys: [],
      // serviceCharge: 350,
      feeInfo: {},
      rules: {
        checked: [
          {
            validator: checkedVal
          }
        ],
        tradeAccount: [
          {
            required: true,
            validator: checkInputAccountNum,
            trigger: 'change'
          }
        ],
        bank_card_number: [
          {
            required: true,
            message: this.$t('withdrawal.error_bank_card_number'),
            trigger: 'change'
          }
        ],
        withdrawal_amount: [
          // {
          //   trigger: 'change'
          // },
          {
            validator: checkInputBlance,
            required: true,
            trigger: ['change', 'blur']
          }
        ],
        withdrawal_bank_name: [
          {
            required: true,
            message: this.$t('withdrawal.error_withdrawal_bank_name'),
            trigger: 'change'
          }
        ],
        withdrawal_bank_card: [
          {
            required: true,
            message: this.$t('withdrawal.error_withdrawal_bank_card'),
            trigger: 'change'
          }
        ],
        withdrawal_swift_no: [
          {
            validator: checkSwiftCode,
            required: true,
            message: this.$t('withdrawal.error_withdrawal_swift_no'),
            trigger: 'change'
          }
        ]
      },
      type: '',
      subLoading: false,
      formLoading: false,
      helpDialog: false,
      mt5Amount: 0,
      totalAmount: 0,
      tradeAccountTypeReal: '',
      chargeInfoList: []
      // serviceCharge: 0,
      // curChargeInfo: {}
    }
  },
  computed: {
    ...mapGetters(['getUser', 'valueAccountNumber', 'getClientProfile', 'getAccountInfo']),
    firstName () {
      return this.getClientProfile && this.getClientProfile.userInfo ? this.getClientProfile.userInfo.firstName : ''
    },
    lastName () {
      return this.getClientProfile && this.getClientProfile.userInfo ? this.getClientProfile.userInfo.lastName : ''
    },
    withdrawal_name () {
      console.log(this.firstName + this.lastName, '-->><')
      return `${this.firstName} ${this.lastName}`
    },
    dialogParams () {
      return { orderId: this.orderId }
    },
    HKDBalance () {
      if (!this.cashList.length) return 0
      if (!this.cashList.find(item => item.currency === 'HKD')) return 0
      return this.cashList.find(item => item.currency === 'HKD').amount
    },
    USDBalance () {
      if (!this.cashList.length) return 0
      if (!this.cashList.find(item => item.currency === 'USD')) return 0
      if (this.type !== 'FOREX') {
        return this.cashList.find(item => item.currency === 'USD').amount
      } else {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.mt5Amount = this.cashList.find(item => item.currency === 'USD').amount
        return this.cashList.find(item => item.currency === 'USD').maxAmount
      }
    },
    CNYBalance () {
      if (!this.cashList.length) return 0
      if (this.tradeAccountType === 'futuresMargin') {
        if (!this.cashList.find(item => item.currency === 'CNH')) return 0
        return this.cashList.find(item => item.currency === 'CNH').amount
      } else {
        if (!this.cashList.find(item => item.currency === 'CNY')) return 0
        return this.cashList.find(item => item.currency === 'CNY').amount
      }
    },
    formatHKDBalance () {
      return (this.HKDBalance.toFixed(2) + '').replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
    },
    formatUSDBalance () {
      return (this.USDBalance.toFixed(2) + '').replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
    },
    formatCNYBalance () {
      return (this.CNYBalance.toFixed(2) + '').replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
    },
    withdrawalAmountCurrency () {
      if (['STOCK', 'FUTURES'].includes(this.type)) return 'HKD'
      if (['FOREX', 'PM'].includes(this.type)) return 'USD'
      return 'HKD'
    },
    serviceCharge() {
      let serviceCharge = 0
      this.chargeInfoList.forEach(item => {
        if (item.businessCcy === this.withdrawalAmountCurrency && item.accountType === this.type) {
          serviceCharge = item.exchangeAmount
        }
      })
      return serviceCharge
    },
    curChargeInfo() {
      let curChargeInfo = {}
      this.chargeInfoList.forEach(item => {
        if (item.businessCcy === this.withdrawalAmountCurrency && item.accountType === this.type) {
          curChargeInfo = item
        }
      })
      return curChargeInfo
    }
  },
  watch: {
    'form.bank_card_number': function (val) {
      for (const value of this.bankCardNumber) {
        if (value.number === val) {
          this.bank_card_name = value.name
          console.log(this.bank_card_name)
          break
        }
      }
    },
    cashList: {
      handler(val) {
        if (val) {
          if (this.type === 'STOCK' || this.type === 'FUND') {
            if (!val.length || !val.find(item => item.currency === this.withdrawalAmountCurrency)) {
              this.totalAmount = 0
            } else {
              this.totalAmount = val.find(item => item.currency === this.withdrawalAmountCurrency).maxAmount || 0
            }
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.getHandingCharge()
  },
  methods: {
    getHandingCharge() {
      let param = {
        businessType: 'OVERSEA_WITHDRAWAL'
      }
      getHandingCharge(param).then(res => {
          if (res.code === 200) {
            this.chargeInfoList = res.data
          }
      })
    },
    tradeAccountConfig (tradeAccountType) {
      return this.Util.getTradeAccountConfig(tradeAccountType)
    },
    async getActiveManageFee () {
      let params = {
        currency: this.withdrawalAmountCurrency,
        type: this.type,
        tradeAccountNumber: this.form.tradeAccount,
        feeType: 'WITHDRAWAL',
        amount: this.form.withdrawal_amount
      }
      let res = await api1.getActiveManageFee(params)
      if (res && res.code === 200) {
        this.feeInfo = res.data ? res.data : {}
      } else {
        this.feeInfo = {}
      }
      // api1.getActiveManageFee(params).then(res => {
      //   this.feeInfo = res.data ? res.data : {}
      // })
    },
    getTotalAmount () {
      let params = {
        currency: this.withdrawalAmountCurrency,
        type: this.tradeAccountTypeReal,
        tradeAccountNumber: this.form.tradeAccount
      }
      tradeApi.getTotalAmount(params).then(res => {
        let data = res.data ? res.data : {}
        this.totalAmount = data.amount ? data.amount : 0
      })
    },
    submitFn (formName) {
      const self = this
      this.$refs[formName].validate(async (valid, error) => {
        if (!valid) return
        if (!this.imageKeys.length) {
          self.$message({
            message: this.$t('common.uploadImg'),
            type: 'error'
          })
          return
        }
        let isNeedPoint = false
        // 外汇 [建议最大可提金额]<[取款金额]≤“可用预付款” 需提示强平风险
        // if (this.type === 'FOREX') {
        //   if (Number(this.USDBalance) < Number(this.form.withdrawal_amount) && Number(this.form.withdrawal_amount) <= Number(this.mt5Amount)) {
        //     isNeedPoint = true
        //   } else {
        //     isNeedPoint = false
        //   }
        // } else {
        //   isNeedPoint = false
        // }
        this.$emit('isNeedPointFun', isNeedPoint)
        self.subLoading = true
        this.form.withdrawal_name = this.withdrawal_name
        await this.getActiveManageFee()
        console.log('self.form>>>>', self.form)
        self.form = {
          ...self.form,
          serviceCharge: this.serviceCharge,
          accountFee: 0,
          currency: this.withdrawalAmountCurrency
          // actualAmount: (self.form.withdrawal_amount - this.serviceCharge) >= 0
          //   ? (Math.round(self.form.withdrawal_amount * 100) - Math.round(this.serviceCharge * 100)) / 100 : 0
        }
        // 仅有账户管理费
        if (self.feeInfo.isNeedFee && !self.feeInfo.isNeedFeeFinance) {
          self.form.accountFee = self.feeInfo.activeManageFee
          self.form.actualAmount = (self.form.withdrawal_amount - self.feeInfo.activeManageFee - self.serviceCharge) >= 0
            ? (Math.round(self.form.withdrawal_amount * 100) - Math.round(self.feeInfo.activeManageFee * 100) - Math.round(self.serviceCharge * 100)) / 100 : 0
          delete self.form.financeFee
        } else if (!self.feeInfo.isNeedFee && self.feeInfo.isNeedFeeFinance) {
          // 仅有一手融手续费
          self.form.financeFee = self.feeInfo.financeFee
          self.form.actualAmount = (self.form.withdrawal_amount - self.feeInfo.financeFee - self.serviceCharge) >= 0
            ? (Math.round(self.form.withdrawal_amount * 100) - Math.round(self.feeInfo.financeFee * 100) - Math.round(self.serviceCharge * 100)) / 100 : 0
          delete self.form.accountFee
        } else if (self.feeInfo.isNeedFee && self.feeInfo.isNeedFeeFinance) {
          // 账户管理费和一手融手续费都有
          self.form.accountFee = self.feeInfo.activeManageFee
          self.form.financeFee = self.feeInfo.financeFee
          self.form.actualAmount = (self.form.withdrawal_amount - self.feeInfo.financeFee - self.feeInfo.activeManageFee - self.serviceCharge) >= 0
            ? (Math.round(self.form.withdrawal_amount * 100) - Math.round(self.feeInfo.financeFee * 100) - Math.round(self.feeInfo.activeManageFee * 100) - Math.round(self.serviceCharge * 100)) / 100 : 0
        } else {
          self.form.actualAmount = (self.form.withdrawal_amount - self.serviceCharge) >= 0
            ? (Math.round(self.form.withdrawal_amount * 100) - Math.round(self.serviceCharge * 100)) / 100 : 0
          delete self.form.financeFee
          delete self.form.accountFee
        }
        self.$emit('submitFn', self.form, self.type, self.imageKeys)
        self.subLoading = false
      })
    },
    uploadHandle (imageKeys) {
      this.imageKeys = imageKeys
    },
    tradeAccountChange (tradeAccountObj) {
      this.form.withdrawal_amount = ''
      this.form.tradeAccount = tradeAccountObj.value
      this.type = tradeAccountObj.type
      this.tradeAccountTypeReal = tradeAccountObj._tradeAccountType
      // this.getActiveManageFee()
      if (this.type !== 'STOCK' && this.type !== 'FUND') {
        this.getTotalAmount()
      }
      this.$emit('getAccountNumber', tradeAccountObj)
      // if (this.form.withdrawal_amount) {
      //   this.$refs['withdrawal_amount'].onFieldChange()
      // }
    },
    // 重置表单
    resetForm () {
      // 重置上传组件图片列表
      this.$refs.uploadPicture.clearImageKeys()
      // 重置交易账户选项
      this.$refs.AccountNumbers.resetAccount()
      this.type = ''
      this.form = {
        tradeAccount: '',
        withdrawal_amount: '',
        withdrawal_name: '',
        bankType: 'OTHER',
        withdrawal_bank_name: '',
        withdrawal_bank_card: '',
        withdrawal_swift_no: ''
      }
      this.$nextTick(() => {
        // 这里处理表单清空后不触发校验问题
        this.$refs.form.clearValidate()
      })
      this.$emit('resetWithdrawalForm', this.form, this.type, this.imageKeys)
    },
    handleClose () {
      this.helpDialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
.oversea-container {
  .input_currency {
    position: relative;
    .help-box {
      position: absolute;
      top: -21px;
      left: 103px;
    }
  }
}
.help-dialog {
  /deep/.el-dialog__body {
    padding: 0 30px 30px;
  }
}
.service-charge {
  margin-bottom: 16px;
  .charge-left {
    font-size: 12px;
    color: #83909D
  }
  .charge-right {
    font-size: 14px;
    color: #1C212A;
    margin-left: 10px;
  }
}
</style>
